// extracted by mini-css-extract-plugin
export default {"container":"footer_container__4DVBb","copyright":"footer_copyright__0JIJ-"};